import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CreateUpdateReasonModel } from "src/app/admin/models/reason-model";
import { ReasonService } from "src/app/admin/services/reason.service";
import { BaseComponent } from "src/app/shared/base/base-component";

@Component({
  selector: "app-create-edit-reason",
  templateUrl: "./create-edit-reason.component.html",
  styleUrls: ["./create-edit-reason.component.scss"],
})
export class CreateEditReasonComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  @Input() reason: CreateUpdateReasonModel;

  private description_regex = /^[a-zA-Z-\u0621-\u064A\s]+$/;
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private reasonService: ReasonService
  ) {
    super();
  }

  ngOnInit(): void {
    this.createForm();
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }
  private createForm() {
    this.formGroup = this.fb.group({
      id: [this.reason?.id],
      description: [this.reason?.description],
      reasonTypeId: [this.reason?.reasonTypeId],
    });

    this.formGroup.statusChanges.subscribe(() => {
      /* console.log("test ", result)*/
    });

    this.setCustomValidators();
  }
  private setCustomValidators() {
    const description: any | undefined = this.formGroup.get("description");
    description.setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(60), Validators.pattern(this.description_regex)]);
    description.updateValueAndValidity();
  }
  private resetForm() {
    this.submitted = false;
    this.createForm();
  }
  public save() {
    this.submitted = true;
    if (this.formGroup.valid) {
      if (!this.reason) this.reason = {} as CreateUpdateReasonModel;

      const data = this.form_Group.controls;
      this.reason.description = data["description"].value;
      const action = !this.reason.id
        ? this.reasonService.Create(this.reason)
        : this.reasonService.Update(this.reason);
      const sub = action.subscribe(
        () => {
          const action = !this.reason.id
            ? this.translate.get("Reasons.AddedSuccessfully")
            : this.translate.get("Reasons.UpdatedSuccessfully");
          action.subscribe((msg) => this.showSuccessMessage(msg));
          this.resetForm();
          this.dismiss();
        },
        (error) => {
          this.submitted = false;
          if (error.status === 403)
            this.translate
              .get(`Reasons.${error.error.error.message}`)
              .subscribe((msg) => this.showErrorMessage(msg));
          else
            this.translate
              .get("ErrorCodes.CreateError")
              .subscribe((msg) => this.showErrorMessage(msg));

          return this.logException(error);
        }
      );

      this.subscription.push(sub);
    }
  }
  public dismiss() {
    this.submitted = false;
    this.createForm();

    this.activeModal.close(true);
  }
}
